import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { LeadsListFilterKeys } from 'pages/UsersPage/model/types';
import { LeadSource } from 'entities/Lead';
import { MultipleSelect } from 'shared/ui/MultipleSelect';

interface LeadSourceSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  onClear: (filterKey: string) => void;
}

export const LeadSourceSelect: FC<LeadSourceSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'user']);

  const leadSourceSelectOptions = useMemo<Array<{ label: string; value: LeadSource }>>(() => {
    return [
      { label: t('Google ads', { ns: 'user' }), value: LeadSource.GOOGLE_ADS },
      { label: t('Seo', { ns: 'user' }), value: LeadSource.SEO },
      { label: t('Lead generator', { ns: 'user' }), value: LeadSource.LEAD_GENERATOR },
      { label: t('Instagram', { ns: 'user' }), value: LeadSource.INSTAGRAM },
      { label: t('Facebook', { ns: 'user' }), value: LeadSource.FACEBOOK },
      { label: t('Social media ads', { ns: 'user' }), value: LeadSource.SOCIAL_MEDIA_ADS },
      { label: t('Unknown source', { ns: 'user' }), value: LeadSource.UNKNOWN },
    ];
  }, [t]);

  const clearFilter = useCallback(() => {
    onClear(LeadsListFilterKeys.sources);
  }, [onClear]);

  const handleChange = useCallback(
    (value: string[]): void => {
      value.length ? onChange(value) : clearFilter();
    },
    [onChange, clearFilter],
  );

  return (
    <MultipleSelect
      containerClassName="flex-1"
      className="w-full"
      label={t('Sources', { ns: 'user' })}
      placeholder={t('All')}
      bordered
      allowClear
      options={leadSourceSelectOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
